import { FormControl, FormGroup } from '@angular/forms'

export class FormUtils {
  public static markFieldsAsTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field)
      if (control instanceof FormControl) {
        control.markAsTouched()
        control.updateValueAndValidity()
      }
    })
  }

  public static clearControlValidators(control: FormControl): void {
    control.clearValidators()
    control.clearAsyncValidators()
    control.markAsUntouched()
    control.setErrors(null)
    control.updateValueAndValidity()
  }

  public static isFormEmpty(formGroup: FormGroup): boolean {
    return Object.values(formGroup.getRawValue()).every((value) => !value)
  }

  public static getMaxLengthFromValidator(control?: FormControl): number | null {
    const validatorFn = control?.validator

    if (!validatorFn) {
      return null
    }

    const errors = validatorFn(new FormControl('.'.repeat(10001)))
    return errors?.['maxlength']?.['requiredLength'] ?? null
  }

  public static scrollToFirstInvalidField(): void {
    const invalidElement = document.querySelector('mat-form-field .ng-invalid')

    if (invalidElement) {
      const scrollToInvalid = () => {
        invalidElement.scrollIntoView({ behavior: 'smooth' })
        ;(invalidElement as HTMLElement).focus({ preventScroll: true })
      }

      // check if element is inside a Material Expansion Panel
      const panel = invalidElement.closest('mat-expansion-panel')

      if (panel) {
        const isExpanded = panel.classList.contains('mat-expanded')

        if (!isExpanded) {
          const content = panel.querySelector('.mat-expansion-panel-content') as HTMLElement

          const onTransitionEnd = (event: TransitionEvent) => {
            if (event.target === content) {
              scrollToInvalid()
              content?.removeEventListener('transitionend', onTransitionEnd)
            }
          }

          // wait for panel to open before scrolling
          content?.addEventListener('transitionend', onTransitionEnd)

          const header = panel.querySelector('mat-expansion-panel-header') as HTMLElement
          header?.click()
          return
        }
      }

      scrollToInvalid()
    }
  }
}
